import { StudentSimulationState } from '../../../types/v2';

export const acceptSimulationState = (
  current: StudentSimulationState | null,
  incoming: StudentSimulationState | null | undefined,
): StudentSimulationState | null => {
  if (!incoming) return current;
  if (!current) return incoming;
  if (incoming.step_id !== current.step_id || incoming.case_id !== current.case_id) {
    return current;
  }
  return incoming.revision >= current.revision ? incoming : current;
};

export const createClientActionId = (): string => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  const random = Math.random().toString(16).slice(2).padEnd(12, '0').slice(0, 12);
  return `00000000-0000-4000-8000-${random}`;
};
